export const webStorage: string = 'https://boomersquad-web-images.s3.amazonaws.com'